/* Keep Richpanel's closed launcher clear of the actual mobile purchase bar. */
(() => {
  const selector = '.rp-micro-app-dummy-icon-container, #richpanel_messenger_iframe';
  const owned = new Map();
  let pending = false;
  function restore(el) {
    const saved = owned.get(el);
    if (!saved) return;
    // Leave a newer value supplied by Richpanel untouched.
    if (el.style.getPropertyValue('bottom') === saved.applied) {
      if (saved.value) el.style.setProperty('bottom', saved.value, saved.priority);
      else el.style.removeProperty('bottom');
    }
    owned.delete(el);
  }
  function update() {
    pending = false;
    let top = Infinity;
    if (matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('[data-mb-sticky-atc]').forEach(bar => {
        const r = bar.getBoundingClientRect();
        const s = getComputedStyle(bar);
        if (r.width && r.height && r.bottom > 0 && r.top < innerHeight &&
            s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0.5) {
          top = Math.min(top, r.top);
        }
      });
    }
    for (const el of owned.keys()) {
      if (!el.isConnected) owned.delete(el);
    }
    document.querySelectorAll(selector).forEach(el => {
      const closed = el.matches('.rp-micro-app-dummy-icon-container') ||
        el.classList.contains('richpanel-messenger-closed');
      if (!closed || !Number.isFinite(top)) { restore(el); return; }
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      if (!rect.width || !rect.height || style.display === 'none') return;
      const current = parseFloat(style.bottom);
      if (!Number.isFinite(current)) return;
      // Both rectangles use the same viewport coordinates, including Safari's
      // browser controls. Place the entire launcher frame 12px above the bar.
      const delta = rect.bottom - (top - 12);
      if (Math.abs(delta) < 0.5) return;
      let saved = owned.get(el);
      if (!saved) {
        saved = { value: el.style.getPropertyValue('bottom'),
          priority: el.style.getPropertyPriority('bottom'), applied: '' };
        owned.set(el, saved);
      }
      const next = `${Math.max(0, current + delta)}px`;
      if (next === saved.applied && el.style.getPropertyValue('bottom') === next) return;
      saved.applied = next;
      el.style.setProperty('bottom', next, 'important');
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  // Richpanel replaces its initial launcher and may update inline positioning.
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });
  new ResizeObserver(schedule).observe(document.body);
  addEventListener('resize', schedule, { passive: true });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  visualViewport?.addEventListener('resize', schedule, { passive: true });
  visualViewport?.addEventListener('scroll', schedule, { passive: true });
  schedule();
})();
